class AdapterStrategy {
    private strategy;
    constructor() {
        this.strategy = null;
    }
    setStrategy(strategy){
        this.strategy = strategy;
    }
    adapt(object: {[key: string]: any}): any {
        return this.strategy.adapt(object);
    }
}

export default AdapterStrategy;